import { featureFlagsApiRef, useApi } from '@backstage/frontend-plugin-api';

export const NEW_FRONTEND_SYSTEM_FLAG = 'new-frontend-system';

export const useNewFrontendSystem = (): boolean =>
  useApi(featureFlagsApiRef).isActive(NEW_FRONTEND_SYSTEM_FLAG);
